import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BUSNQuoteScheduleService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import { SharedConfig, SharedDialogService, SharedFormulaService } from '@takectrl-multiapp/svcs-share-config';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
declare const dataLayer: any[];

@Component({
  selector: 'quote-added-benefits',
  standalone: false,
  templateUrl: './quote-added-benefits.component.html',
  styleUrls: ['./quote-added-benefits.component.scss'],
})
export class QuoteAddedBenefitsComponent implements OnInit {
  @Output() navigateNeedsAnalysis: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateToQuoteNew: EventEmitter<unknown> = new EventEmitter<unknown>();
  collectionDates = [];
  showDeductionDay = false;
  collection_day: string;
  showFetchingQuotesAnimation = false;
  showSuccess = false;
  hide_deduction_input: boolean = false;
  constructor(
    public sharedConfig: SharedConfig,
    private readonly busnQuoteScheduleService: BUSNQuoteScheduleService,
    public busnThirdPartyService: BUSNThirdPartyService,
    public userService: BUSNUserService,
    private readonly busnCommService: BUSNCommunicationService,
    private readonly sharedFormulaService: SharedFormulaService,
    private readonly sharedDialogService: SharedDialogService
  ) {
    this.cantQuote = this.cantQuote.bind(this);
  }

  ngOnInit(): void {
    this.collectionDates = this.sharedFormulaService.getDateOrdinalsForMonth();
    dataLayer.push({
      event: 'page_show',
      screenPath: 'quote-added-benefits',
      screenName: 'quote-added-benefits',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  cantQuote() {
    this.navigateToQuoteNew.emit();
    this.sharedDialogService.hidePopupDialog();
  }

  updateQuoteRequestAddedBenefitsAndContinue(assistance_benefits_requested = false) {
    this.sharedConfig.quoteRequest.assistance_benefits_requested = assistance_benefits_requested;
    this.busnQuoteScheduleService.updateQuoteRequest(this.sharedConfig.quoteRequest);
    this.busnThirdPartyService.logEvent('action_assistance_accepted', { didAccept: assistance_benefits_requested });
    this.navigateNeedsAnalysis.emit();
  }
  itcCheckAgree() {
    this.userService.updateUserItc();
    this.busnThirdPartyService.logEvent('action_agreed_itc_check');
  }

  onCollectionDaySelected(collection_day) {
    this.showDeductionDay = false;
    this.collection_day = collection_day.day_ordinal_display_name;
    this.sharedConfig.quoteRequest.cover_premium_date = collection_day.day;
    SharedConfig.showFullScreen = false;
  }

  async openDeductionDay() {
    SharedConfig.showFullScreen = true;
    this.sharedConfig.setShowCustomLoader(true)
    const intervalId = setInterval(() => {
      this.sharedConfig.setShowCustomLoader(false)
      this.showDeductionDay = true;
      clearInterval(intervalId);
    }, 100);
  }

  async submitQuoteRequest() {
    if (!this.sharedConfig.user.providers?.premia_client_id) {
        try {
          const create_lead = await this.userService.createLead();
          if (create_lead.success) {
            const user = await this.userService.getUser(SharedConfig.firebaseUserKey)
            this.sharedConfig.setUser(user);
            this.submitQuoteRequest();
          } else {
            this.sharedDialogService.showPopupDialog({
              header: 'Warning',
              subHeader: create_lead.message,
              buttonOneText: 'OK',
              buttonOneCallback: this.sharedDialogService.hidePopupDialog,
            });
          }
        } catch (error) {
          this.sharedDialogService.showPopupDialog({
            header: 'Something went wrong',
            subHeader: 'Create lead failed.',
            buttonOneText: 'OK',
            buttonOneCallback: this.sharedDialogService.hidePopupDialog,
          });
        }
      } else {
        await this.busnQuoteScheduleService.updateQuoteRequest(this.sharedConfig.quoteRequest);
        if (this.sharedConfig.appSettings.show_need_analysis) {
          this.navigateNeedsAnalysis.emit();
        } else {
          if (this.sharedConfig.userPermissions?.can_quote) {
            this.hide_deduction_input = true;
            this.showFetchingQuotesAnimation = true;
            SharedConfig.showFullScreen = true;
          this.busnQuoteScheduleService.submitQuoteRequest().then( (response) => {
              this.showFetchingQuotesAnimation = false;
              if (response.success) {
                this.showSuccess = true;
              } else {
                this.hide_deduction_input = false;
                this.sharedDialogService.showPopupDialog({
                  header: 'Something went wrong',
                  subHeader: response.message,
                  buttonOneText: 'OK',
                  buttonOneCallback: this.sharedDialogService.hidePopupDialog,
                });
              }
            });
          } else {
            this.sharedDialogService.showPopupDialog({
                header: 'Please note!',
                subHeader: 'Quoting has been disbled.',
                buttonOneText: 'OK',
                buttonOneCallback: this.cantQuote,
              });
          }
        }
      }
  }

  chatToUs() {
    this.busnThirdPartyService.logEvent('action_itc_chat_to_us');
    this.busnCommService.openContactCardPopup()
  }
}
